import React from "react";
import { LOGO_URL } from "@/siteData";

export function BrandMark({ compact = false }) {
  return (
    <span className={`brand-mark${compact ? " brand-mark-compact" : ""}`}>
      <img className="brand-logo-image" src={LOGO_URL} alt="Pop Social Events official logo" />
      <span className="brand-wordmark"><span>POP</span><b>·</b><span>SOCIAL</span></span>
    </span>
  );
}
